import { createFileRoute, redirect } from "@tanstack/react-router";

// URL antigua: redirige para siempre a la landing /lp/test-supervivencia.
export const Route = createFileRoute("/test-supervivencia")({
  beforeLoad: () => {
    throw redirect({ to: "/lp/test-supervivencia", statusCode: 301 });
  },
});
